<template>
  <div class="g-tabsBody">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'GTabsBody'
}
</script>

<style scoped>
.g-tabsBody {
}
</style>
